import { Utils } from '@m4u-angular/core/helpers/Utils';
import { ChangeCreditCardDialogComponent } from './Components/change-credit-card-dialog/change-credit-card.component';
import { CustomerEndpoint } from '@dato-proxy/endpoints/customer.endpoint';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, BaseEntityResponse, BaseEntitiesResponse } from '@m4u-angular/base/entities/BaseEntities';
import { Component, ViewChild } from '@angular/core';
import { BaseEntity } from '@m4u-angular/base/entities/BaseEntities';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { Customer } from '@dato-proxy/entities/customer.entity';
import { Globals } from '../../_globals';
import { EnumCRUDActions } from '@m4u-angular/core/framework/sysenums.enum';
import { EnumCustomerAddressTypes } from '@dato-proxy/enums';
import { SystemOptionView } from '@dato-proxy/views/systemoption.view';
import { ContactPersonEndpoint } from '@dato-proxy/endpoints/contactperson.endpoint';
import { CustomerAddressEndpoint } from '@dato-proxy/endpoints/customeraddress.endpoint';
import { ContactPerson } from '@dato-proxy/entities/contactperson.entity';
import { CustomerAddress } from '@dato-proxy/entities/customeraddress.entity';
import { CustomerAddressesListParams } from '@dato-proxy/params/customeraddresseslist.param';

class State extends BaseState {
    Customer: Customer;
    CurrentTabIndex =  0;
    CurrentTab: any;
    CurrentAddressTabIndex = 0;
    CurrentAddressTab: any;
    Options: SystemOptionView;
    IsActiveUser: boolean;

    ContactPersons: ContactPerson[];
    BillCustomerAddresses: CustomerAddress[];
    ShipCustomerAddresses: CustomerAddress[];
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-my-details',
    templateUrl: './my-details.component.html',
    styleUrls: ['./my-details.component.scss']
})
export class MyDetailsComponent extends BasePageComponent<BaseEntity, State> {
    @ViewChild(ChangeCreditCardDialogComponent) changeCreditCardDialogComponent: ChangeCreditCardDialogComponent;
    public EnumCustomerAddressTypes = EnumCustomerAddressTypes;

    MyDetailsTabs = [];
    CustomerAddressTabs = [];

    constructor(A: ServiceBagService,
        private customerEndpoint: CustomerEndpoint,
        private contactPersonEndpoint: ContactPersonEndpoint,
        private customerAddressEndpoint: CustomerAddressEndpoint) {
        super(A, 'MyDetailsComponent', BaseEntity, State);
    }

    override OnInitComponent() {
        this.State.Options = Globals.SystemOption;
        this.State.IsActiveUser = Globals.IsActiveUser;
        this.State.CurrentTabIndex = this.State.CurrentAddressTabIndex = 0;
        this.InitMyDetailsTabs();
        if (!Globals.SystemOption.IsAllowMyDetails) { this.Navigate(['/system/login']); }
        this.InitCustomer();
        this.LoadData();
    }

    InitMyDetailsTabs() {
        const myDetailsTabs = this.LIST('MyDetailsTabs') as any[];
        
        if (this.State.Options.IsAllowContactPersons) {
            const contactPersonsTab = myDetailsTabs.find(x => x.Name === 'ContactPersons');
            contactPersonsTab && this.MyDetailsTabs.push(contactPersonsTab);
        }

        const customerAddressesTabs = this.LIST('CustomerAddressTabs') as any[];
        if (this.State.Options.IsAllowBillCustomerAddresses) {
            const billAddressesTab = customerAddressesTabs.find(x => x.Name === 'BillCustomerAddresses');
            billAddressesTab && this.CustomerAddressTabs.push(billAddressesTab);
        }
        if (this.State.Options.IsAllowShipCustomerAddresses) {
            const shipAddressesTab = customerAddressesTabs.find(x => x.Name === 'ShipCustomerAddresses');
            shipAddressesTab && this.CustomerAddressTabs.push(shipAddressesTab);
        }

        if (this.CustomerAddressTabs.length) {
            const customerAddressesTab = myDetailsTabs.find(x => x.Name === 'CustomerAddresses');
            customerAddressesTab && this.MyDetailsTabs.push(customerAddressesTab);
        }
    }

    OnSelectedTabIndexChanged(index: number) {
        this.State.CurrentTab = this.MyDetailsTabs[index];
        this.State.CurrentTabIndex = index;
    }

    override OnExternalEntitySaved(ExternalEntity: BaseEntity, ExternalEntityType: new () => BaseEntity, ExternalEntityAction: EnumCRUDActions) {
        if (ExternalEntityType === Customer) { this.InitCustomer(); }
        if (ExternalEntityType === CustomerAddress) this.LoadCustomerAddresses();
        if (ExternalEntityType === ContactPerson) this.LoadContactPersons();
    }

    IsShowEmptyField() {
        return this.State.Options.IsShowCreditCard || this.State.Options.IsShowBankDetails || this.State.Options.IsShowMaxBalance || this.State.Options.IsShowMaxObligo;
    }

    OnGotoDetails(goto: 'balance' | 'obligo') {
        const path = this.A.Screen.IsDesktop() ? '/pages/reports' : '/pages/accounting';
        switch (goto) {
            case 'balance':
                if (Globals.SystemOption.IsAllowLedger) { this.Navigate([path]); }
                break;
            case 'obligo':
                if (Globals.SystemOption.IsAllowDeliveries) { this.Navigate([path], { Tab: 3 }); }
                break;
            default:
        }
    }

    OnEditCreditCard() {
        if (Globals.SystemOption.IsAllowCreditCardEdit) {
            this.changeCreditCardDialogComponent.ShowDialogShort(() => { this.InitCustomer(); });
        }
    }

    OnEditBankDetails() {
        if (this.State.Options.IsAllowBankDetailsEdit) {
            this.Navigate(['/pages/bank-details']);
        }
    }

    OnGetBankDetails() {
        if (this.State.Customer && !Utils.IsEmpty(this.State.Customer.DefaultBank) && !Utils.IsEmpty(this.State.Customer.DefaultBranchCode) && !Utils.IsEmpty(this.State.Customer.DefaultAccount)) {
            return `${this.State.Customer.DefaultBankName} - ${this.State.Customer.DefaultBank}-${this.State.Customer.DefaultBranchCode}-${this.State.Customer.DefaultAccount}`;
        }

        return this.RC('lblBankDetailsEmpty');
    }

    OnSelectedAddressTabIndexChanged(index: number) {
        this.State.CurrentAddressTab = this.CustomerAddressTabs[index];
        this.State.CurrentAddressTabIndex = index;
    }

    private InitCustomer() {
        this.Do(this.customerEndpoint.GetCurrent(), false, (response: BaseEntityResponse<Customer>) => {
            this.State.Customer = response.Entity;
        });
    }

    private LoadData() {
        this.LoadContactPersons();
        this.LoadCustomerAddresses();
    }

    private LoadContactPersons() {
        if (!this.State.Options?.IsAllowContactPersons) return;

        this.Do(this.contactPersonEndpoint.GetList(), false, (response: BaseEntitiesResponse<ContactPerson>) => {
            this.State.ContactPersons = response.Entities;
        });
    }

    private LoadCustomerAddresses() {
        if (this.State.Options?.IsAllowBillCustomerAddresses) {
            this.LoadCustomerAddressByType(this.Enums.EnumCustomerAddressTypes.Bill).subscribe((response: BaseEntitiesResponse<CustomerAddress>) => {
                this.State.BillCustomerAddresses = response.Entities;
            });
        }

        if (this.State.Options?.IsAllowShipCustomerAddresses) {
            this.LoadCustomerAddressByType(this.Enums.EnumCustomerAddressTypes.Ship).subscribe((response: BaseEntitiesResponse<CustomerAddress>) => {
                this.State.ShipCustomerAddresses = response.Entities;
            });
        }
    }

    private LoadCustomerAddressByType(type: EnumCustomerAddressTypes) {
        let params = new CustomerAddressesListParams();
        params.Type = type;

        return this.customerAddressEndpoint.ListEx(params, null);
    }

}
